import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $usersStore } from '@lib/store';
import { UserType } from '@shared/api/rest/users';
import { Managers } from './managers';
import { ModalAddManager } from './modalAddManagers';
import { ModalRemoveManager } from './modalRemoveManager';
import { Button, Spinner, Text } from '@shared/widgets';

interface PropsType {
  accountId: number;
}

export const ManagersBlock = (props: PropsType) => {
  const managersData = useUnit($usersStore.store);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalRemove, setModalRemove] = useState(false);

  useEffect(() => {
    //TODO connect  assignedAccountId: props.accountId when api ready
    $usersStore.events.update({
      userType: UserType.MANAGER,
      // assignedAccountId: props.accountId,
    });
  }, []);

  const closeAddModal = (confirm?: boolean) => {
    setModalAdd(false);
    if (confirm) $usersStore.events.update({ userType: UserType.MANAGER });
  };
  const closeRemoveModal = (confirm?: boolean) => {
    setModalRemove(false);
    if (confirm) $usersStore.events.update({ userType: UserType.MANAGER });
  };

  return (
    <div className='flex flex-col gap-6'>
      <div className='w-full flex justify-between overflow-x-auto'>
        <Text weight='semibold' size='2xl'>
          Managers
        </Text>
        <div className='flex gap-2'>
          <Button color='outlined' onClick={() => setModalAdd(true)}>
            Add
          </Button>
          <Button color='outlined' onClick={() => setModalRemove(true)}>
            Remove
          </Button>
        </div>
      </div>
      {managersData.loading ? <Spinner /> : <Managers data={managersData.data.filter((m) => m.accounts.includes(props.accountId))} />}
      <ModalAddManager
        isOpen={modalAdd}
        accountId={props.accountId}
        data={managersData.data.filter((m) => !m.accounts.includes(props.accountId))}
        onClose={closeAddModal}
        title='Add Managers'
      />
      <ModalRemoveManager
        title='Remove Managers'
        onClose={closeRemoveModal}
        accountId={props.accountId}
        data={managersData.data.filter((m) => m.accounts.includes(props.accountId))}
        isOpen={modalRemove}
      />
    </div>
  );
};
